import React from 'react';
import "./Bundle.scss";

const AllowanceInfo = ({ allowances, dataAmountForDisplay, fup }) => {
    const dataAllowance = allowances?.find(a => a.type === "DATA");
    const voiceAllowance = allowances?.find(a => a.type === "VOICE");
    const smsAllowance = allowances?.find(a => a.type === "SMS");

    const getDataValue = () => {
        if (dataAllowance) {
            if (dataAllowance.unlimited) return "Unlimited";
        }
        return dataAmountForDisplay || "N/A";
    };

    const getVoiceValue = () => {
        if (voiceAllowance) {
            if (voiceAllowance.unlimited) return "Unlimited";
            return voiceAllowance.amount > 0 ? `${voiceAllowance.amount} ${voiceAllowance.unit || 'Mins'}` : "N/A";
        }
        return "N/A";
    };

    const getSmsValue = () => {
        if (smsAllowance) {
            if (smsAllowance.unlimited) return "Unlimited";
            return smsAllowance.amount > 0 ? `${smsAllowance.amount} ${smsAllowance.unit || 'SMS'}` : "N/A";
        }
        return "N/A";
    };

    const getPackDescription = () => {
        const hasData = (dataAllowance && (dataAllowance.unlimited || dataAllowance.amount > 0)) || !!dataAmountForDisplay;
        const hasVoice = voiceAllowance && (voiceAllowance.unlimited || voiceAllowance.amount > 0);
        const hasSms = smsAllowance && (smsAllowance.unlimited || smsAllowance.amount > 0);

        if (hasData && !hasVoice && !hasSms) {
            return "Data Only Pack (No Voice & No SMS)";
        } else if (!hasData && hasVoice && !hasSms) {
            return "Voice Only Pack (No Data & No SMS)";
        } else if (!hasData && !hasVoice && hasSms) {
            return "SMS Only Pack (No Data & No Voice)";
        } else if (hasData && hasVoice && !hasSms) {
            return "Data & Voice Pack (No SMS)";
        } else if (hasData && !hasVoice && hasSms) {
            return "Data & SMS Pack (No Voice)";
        } else if (!hasData && hasVoice && hasSms) {
            return "Voice & SMS Pack (No Data)";
        } else if (hasData && hasVoice && hasSms) {
            return "Data, Voice & SMS Pack";
        } else {
            return "Data Only Pack (No Voice & No SMS)";
        }
    };

    const hasVoice = voiceAllowance && (voiceAllowance.unlimited || voiceAllowance.amount > 0);
    const hasSms = smsAllowance && (smsAllowance.unlimited || smsAllowance.amount > 0);

    if (!hasVoice && !hasSms) {
        return <div className="bundle-allowance-inline empty"></div>;
    }

    return (
        <div className="bundle-allowance-inline">
            <div className="allowance-items">
               {/* <span className="allowance-item">
                    <i className="pi pi-wifi mr-1"></i>Data: {getDataValue()}
                </span>
                <span className="allowance-sep">|</span> */}
                <span className="allowance-item">
                    <i className="pi pi-phone mr-1"></i>Voice: {getVoiceValue()}
                </span>
                <span className="allowance-sep">|</span>
                <span className="allowance-item">
                    <i className="pi pi-comment mr-1"></i>SMS: {getSmsValue()}
                </span>
            </div>
        </div>
    );
};

export default AllowanceInfo;
